<template>
  <PageWrapper>
    <template #content>
      <div class="px-8 pt-12 pb-24">
        <LoadingSpinner v-if="agentStore.loadingAgent" class="mt-12" />
        <div v-else class="container max-w-6xl mx-auto">
          <article>
            <div class="pb-4" v-if="agentStore.agent">
              <AgentInformation :agent="agentStore.agent" />
            </div>
          </article>
          <article class="mt-4">
            <h1 class="text-2xl font-semibold text-gray-700 mb-1">Domains</h1>
            <div v-if="domains.length">
              <DomainResultList :domains="domains" />
            </div>
            <LoadingSpinner v-else-if="loadingDomains" class="mt-12" />
            <div v-else class="mt-2 w-full text-center text-gray-500">
              No eligible domains
            </div>
          </article>
        </div>
      </div>
    </template>
  </PageWrapper>
</template>

<script setup>
import { formatRelative, parseISO } from "date-fns";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import AgentInformation from "@/components/AgentInformation.vue";
import DomainResultList from "@/components/DomainResultList.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import PageWrapper from "@/components/PageWrapper.vue";
import useAgentStore from "@/stores/agent";
import useUserStore from "@/stores/user";

const route = useRoute();
const agentStore = useAgentStore();

const userStore = useUserStore();
const { vendor, vendorKey } = storeToRefs(userStore);

const domains = ref([]);
const loadingDomains = ref(false);

async function getDomains() {
  loadingDomains.value = true;
  const params = new URLSearchParams([
    ["agent_alias", route.params.alias],
    ["page_size", 100],
    ["product_type", "m1"],
    ["product_type", "m2"],
  ]);
  const response = await fetch(
    `/api/cmp/${vendorKey.value}/domains/?${params.toString()}`,
  );
  if (!response.ok) {
    throw new Error("Failed to get domains");
  }
  const data = await response.json();
  domains.value = data.results;

  loadingDomains.value = false;
}

onMounted(async () => {
  agentStore.getAgent(route.params.alias);
  getDomains();
});
</script>
